// export enum SymptomModes {
//   Simple = 'simple',
//   PreOpScreening = 'preOpScreening',
//   Advanced = 'advanced',
//   FollowUp = 'followUp',
//   Treatment = 'treatment',
//   PreOp = 'preop',
//   Silver = 'silver'
// }

import { QuestionnaireType, StaffType, SubscriptionPlan } from 'src/API';
import { SymptomModes } from 'src/app/shared/symptoms/symptom.model';

// export enum QuestionnaireType {
//   DEQ = 'DEQ',
//   SPEED = 'SPEED',
//   OSDI = 'OSDI',
//   OSDIAndSPEED = 'OSDIAndSPEED',
//   DERFS = 'DERFS',
//   CDERFS = 'CDERFS',
//   SPEEDII = 'SPEEDII',
//   FITZPATRICK = 'FITZPATRICK',
//   MEDICATION = 'MEDICATION',
//   OSDI6 = 'OSDI6',
//   CUSTOM = 'CUSTOM'
// }

export const subscriptionPlanKeyToFriendlyNameMap: { [key in SubscriptionPlan]: string } = {
  [SubscriptionPlan.lite]: 'Essentials',
  [SubscriptionPlan.pro]: 'Pro',
  [SubscriptionPlan.full]: 'Full'
};

export enum IntakeFormType {
  STANDARD = 'standard',
  CONTACT = 'welcome'
}

export enum QuestionnaireDeliveryMethod {
  TEXT = 'TEXT',
  EMAIL = 'EMAIL'
}

export enum Feature {
  MEDIA_WIZARD = 'MEDIA_WIZARD',
  MASS_CLINIC = 'MASS_CLINIC',
  MULTI_CLINIC = 'MULTI_CLINIC',
  COMPARE_ASSESSMENT = 'COMPARE_ASSESSMENT',
  QUESTIONNAIRE_REMINDERS = 'QUESTIONNAIRE_REMINDERS',
  WELCOME_MESSAGE = 'WELCOME_MESSAGE',
  EFAX = 'EFAX',
  AI_SCRIBE = 'AI_SCRIBE',
  NUTRITION_BASED_TESTING = 'NUTRITION_BASED_TESTING'
}

export enum Sign {
  VA = 'VA',
  PRESSURE = 'PRESSURE',
  FLUORESCEIN_STAINING = 'FLUORESCEIN_STAINING',
  NITBUT = 'NITBUT',
  TEAR_MENISCUS_HEIGHT = 'TEAR_MENISCUS_HEIGHT',
  TEAR_MENISCUS_HEIGHT_IMAGING = 'TEAR_MENISCUS_HEIGHT_IMAGING',
  OSMOLARITY = 'OSMOLARITY',
  MMP9 = 'MMP9',
  PARTIAL_BLINKING_FREQUENCY = 'PARTIAL_BLINKING_FREQUENCY',
  BLINKING_FREQUENCY_PER_MIN = 'BLINKING_FREQUENCY_PER_MIN',
  BLINK = 'BLINK',
  LID_APOSITION = 'LID_APOSITION',
  MEIBOGRAPHY = 'MEIBOGRAPHY',
  MEIBOGRAPHY_UPPER = 'MEIBOGRAPHY_UPPER',
  MEIBOGRAPHY_LOWER = 'MEIBOGRAPHY_LOWER',
  EPITHELIAL_THICKNESS = 'EPITHELIAL_THICKNESS',
  LIPID_LAYER = 'LIPID_LAYER',
  LIPID_LAYER_NASAL = 'LIPID_LAYER_NASAL',
  LIPID_LAYER_TEMPORAL = 'LIPID_LAYER_TEMPORAL',
  CORNEAL_SENSATION = 'CORNEAL_SENSATION',
  CORNEAL_FINDINGS = 'CORNEAL_FINDINGS',
  SCHIRMERS_TEST = 'SCHIRMERS_TEST',
  SUPERIOR_CONJUNCTIVA_CORNEAL_FINDINGS = 'SUPERIOR_CONJUNCTIVA_CORNEAL_FINDINGS',
  PHENOL_RED = 'PHENOL_RED',
  SMTUBE = 'SMTUBE',
  FLOPPY_EYELID_SYNDROME_GRADING = 'FLOPPY_EYELID_SYNDROME_GRADING',
  LAGOPHTHALMUS = 'LAGOPHTHALMUS',
  LID_REDNESS = 'LID_REDNESS',
  COLLARETTES = 'COLLARETTES',
  EYELID_TELANGIECTASIA = 'EYELID_TELANGIECTASIA',
  CONJUNCTIVAL_CHALASIS = 'CONJUNCTIVAL_CHALASIS',
  ITBUT = 'ITBUT',
  CORNEAL_STAINING_PATTERN = 'CORNEAL_STAINING_PATTERN',
  CORNEAL_STAINING_EXTENT = 'CORNEAL_STAINING_EXTENT',
  LWE = 'LWE',
  MGE_SECRETION = 'MGE_SECRETION',
  MGE_EXPRESSIBILITY = 'MGE_EXPRESSIBILITY',
  OTHER = 'OTHER',
  EYE_MARKUP = 'EYE_MARKUP',
  MG_ORIFICE_CAPPED_GLANDS = 'MG_ORIFICE_CAPPED_GLANDS',
  MG_ORIFICE_NOTCHES = 'MG_ORIFICE_NOTCHES',
  BULBAR_REDNESS = 'BULBAR_REDNESS',
  LIMBAL_REDNESS = 'LIMBAL_REDNESS',
  UPPER_LID_LAXITY = 'UPPER_LID_LAXITY',
  SNAP_BACK_LID_LAXITY = 'SNAP_BACK_LID_LAXITY',
  KERATINIZATION = 'KERATINIZATION'
}

export enum PDFReportType {
  SIMPLE = 'simple',
  DETAILED = 'detailed',
  SUMMARY = 'summary',
  CUSTOM = 'custom'
}

// export enum StaffType {
//   Owner = 'Owner',
//   Doctor = 'Doctor',
//   Tech = 'Tech',
//   Receptionist = 'Receptionist'
// }

export const signKeyToFriendlyNameMap = {
  VA: 'Visual Acuity',
  PRESSURE: 'Pressure',
  FLUORESCEIN_STAINING: 'Fluorescein Staining',
  NITBUT: 'Non-invasive Tear Breakup Time (NITBUT)',
  TEAR_MENISCUS_HEIGHT: 'Tear Meniscus Height Slit Lamp',
  TEAR_MENISCUS_HEIGHT_IMAGING: 'Tear Meniscus Height Imaging',
  OSMOLARITY: 'Osmolarity',
  MMP9: 'MMP9',
  PARTIAL_BLINKING_FREQUENCY: 'Partial Blinking Frequency (%)',
  BLINKING_FREQUENCY_PER_MIN: 'Blinking Frequency Per Minute',
  BLINK: 'Blink',
  LID_APOSITION: 'Lid Apposition',
  MEIBOGRAPHY: 'Meibography',
  MEIBOGRAPHY_UPPER: 'Meibography Upper',
  MEIBOGRAPHY_LOWER: 'Meibography Lower',
  EPITHELIAL_THICKNESS: 'Epithelial Thickness\n(Look at Superior Cornea)',
  LIPID_LAYER: 'Lipid Layer',
  LIPID_LAYER_NASAL: 'Lipid Layer Nasal',
  LIPID_LAYER_TEMPORAL: 'Lipid Layer Temporal',
  CORNEAL_SENSATION: 'Corneal Sensation',
  CORNEAL_FINDINGS: 'Corneal Findings',
  SCHIRMERS_TEST: "Schirmer's Test (Type 1 with anesthetic)",
  SUPERIOR_CONJUNCTIVA_CORNEAL_FINDINGS: 'Superior Conjunctiva and Corneal Findings',
  PHENOL_RED: 'Phenol Red',
  SMTUBE: 'SM Tube',
  FLOPPY_EYELID_SYNDROME_GRADING: 'Floppy Eyelid Syndrome Grading',
  LAGOPHTHALMUS: 'Lagophthalmos',
  LID_REDNESS: 'Lid Redness',
  COLLARETTES: 'Eyelid Debris (Collarettes)',
  EYELID_TELANGIECTASIA: 'Eyelid Telangiectasia',
  CONJUNCTIVAL_CHALASIS: 'Conjunctival Chalasis',
  ITBUT: 'Invasive Tear Breakup Time (Fluorescein)',
  CORNEAL_STAINING_PATTERN: 'Corneal Staining Pattern',
  CORNEAL_STAINING_EXTENT: 'Vital Dye Staining',
  LWE: 'Lid Wiper Epitheliopathy (LWE)',
  MGE_SECRETION: 'MGE Secretion',
  MGE_EXPRESSIBILITY: 'MGE Expressibility',
  OTHER: 'Additional Notes',
  EYE_MARKUP: 'Eye Markup',
  MG_ORIFICE_CAPPED_GLANDS: 'MG Orifice Capped Glands',
  MG_ORIFICE_NOTCHES: 'MG Orifice Notches',
  BULBAR_REDNESS: 'Bulbar Redness',
  LIMBAL_REDNESS: 'Limbal Redness',
  UPPER_LID_LAXITY: 'Upper Lid Laxity',
  SNAP_BACK_LID_LAXITY: 'Lower Lid Laxity (Snap-Back) Test',
  KERATINIZATION: 'Keratinization'
};

export const questionnaireTypeToFriendlyNameMap: {
  [key in QuestionnaireType]?: string;
} = {
  [QuestionnaireType.DEQ]: 'DEQ',
  [QuestionnaireType.OSDI]: 'OSDI 12',
  [QuestionnaireType.SPEED]: 'SPEED',
  [QuestionnaireType.SPEEDII]: 'SPEED II',
  [QuestionnaireType.OSDIAndSPEED]: 'OSDI 12 and SPEED',
  [QuestionnaireType.DERFS]: 'DERFS',
  [QuestionnaireType.CDERFS]: 'CDERFS',
  [QuestionnaireType.FITZPATRICK]: 'FITZPATRICK',
  [QuestionnaireType.OSDI6]: 'OSDI 6',
  [QuestionnaireType.CUSTOM]: 'CUSTOM',
  [QuestionnaireType.MEDICATION]: 'MEDICATION',
  [QuestionnaireType.DEWSIII_Q]: 'DEWS III Questionnaire'
};

export const encounterMethodToFriendlyNameMap: {
  [key in SymptomModes]?: string;
} = {
  advanced: 'Gold Standard',
  silver: ' Accelerated Dry Eye Assessment ',
  preOpScreening: 'Pre-Operative Screening',
  simple: 'Screening',
  preop: 'ASCRS Pre-Op',
  treatment: 'Treatment',
  followUp: 'Follow Up'
};

export enum AccessState {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  HIDDEN = 'HIDDEN',
  PRO_LOCKED = 'PRO_LOCKED',
  ADD_ON_LOCKED = 'ADD_ON_LOCKED',
  PRO_OR_ADD_ON_LOCKED = 'PRO_OR_ADD_ON_LOCKED'
}

export interface AccessConfig {
  accessState: AccessState;
}

/**
 * Max two levels of nesting. For example questionnaires.DEQ is two levels already.
 */
export interface SubscriptionPlanSchema {
  signs?: { [key in SymptomModes]?: { [key in Sign]?: AccessConfig } };
  questionnaires?: { [key in QuestionnaireType]?: AccessConfig };
  intakeForms?: { [key in IntakeFormType]?: AccessConfig };
  assessments?: { [key in SymptomModes]?: AccessConfig };
  reports?: { [key in PDFReportType]?: AccessConfig };
  sendReports?: { [key in PDFReportType]?: AccessConfig };
  features?: { [key in Feature]?: AccessConfig };
  staffCounts?: { [key in StaffType]?: number };
  questionnaireDeliveryMethods?: {
    [key in QuestionnaireDeliveryMethod]?: AccessConfig;
  };
}

export const liteSubscriptionPlanSchema: SubscriptionPlanSchema = {
  signs: {
    [SymptomModes.Advanced]: {
      [Sign.ITBUT]: { accessState: AccessState.ENABLED },
      [Sign.FLUORESCEIN_STAINING]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_CAPPED_GLANDS]: { accessState: AccessState.ENABLED },
      [Sign.EYELID_TELANGIECTASIA]: { accessState: AccessState.ENABLED },
      [Sign.COLLARETTES]: { accessState: AccessState.ENABLED },
      [Sign.BULBAR_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.MGE_SECRETION]: { accessState: AccessState.ENABLED },
      [Sign.VA]: { accessState: AccessState.PRO_LOCKED },
      [Sign.PRESSURE]: { accessState: AccessState.PRO_LOCKED },
      [Sign.NITBUT]: { accessState: AccessState.PRO_LOCKED },
      [Sign.TEAR_MENISCUS_HEIGHT_IMAGING]: { accessState: AccessState.PRO_LOCKED },
      [Sign.OSMOLARITY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MMP9]: { accessState: AccessState.PRO_LOCKED },
      [Sign.PARTIAL_BLINKING_FREQUENCY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.BLINKING_FREQUENCY_PER_MIN]: { accessState: AccessState.PRO_LOCKED },
      [Sign.BLINK]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LID_APOSITION]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MEIBOGRAPHY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MEIBOGRAPHY_UPPER]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MEIBOGRAPHY_LOWER]: { accessState: AccessState.PRO_LOCKED },
      [Sign.EPITHELIAL_THICKNESS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LIPID_LAYER]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LIPID_LAYER_NASAL]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LIPID_LAYER_TEMPORAL]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CORNEAL_SENSATION]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CORNEAL_FINDINGS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.SCHIRMERS_TEST]: { accessState: AccessState.PRO_LOCKED },
      [Sign.SUPERIOR_CONJUNCTIVA_CORNEAL_FINDINGS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.PHENOL_RED]: { accessState: AccessState.PRO_LOCKED },
      [Sign.SMTUBE]: { accessState: AccessState.PRO_LOCKED },
      [Sign.FLOPPY_EYELID_SYNDROME_GRADING]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LAGOPHTHALMUS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LID_REDNESS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CONJUNCTIVAL_CHALASIS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CORNEAL_STAINING_PATTERN]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CORNEAL_STAINING_EXTENT]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LWE]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MGE_EXPRESSIBILITY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.OTHER]: { accessState: AccessState.PRO_LOCKED },
      [Sign.EYE_MARKUP]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MG_ORIFICE_NOTCHES]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LIMBAL_REDNESS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.UPPER_LID_LAXITY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.SNAP_BACK_LID_LAXITY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.KERATINIZATION]: { accessState: AccessState.PRO_LOCKED }
    },
    [SymptomModes.PreOpScreening]: {
      [Sign.ITBUT]: { accessState: AccessState.ENABLED },
      [Sign.FLUORESCEIN_STAINING]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_CAPPED_GLANDS]: { accessState: AccessState.ENABLED },
      [Sign.EYELID_TELANGIECTASIA]: { accessState: AccessState.ENABLED },
      [Sign.COLLARETTES]: { accessState: AccessState.ENABLED },
      [Sign.BULBAR_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.MGE_SECRETION]: { accessState: AccessState.ENABLED },
      [Sign.VA]: { accessState: AccessState.PRO_LOCKED },
      [Sign.PRESSURE]: { accessState: AccessState.PRO_LOCKED },
      [Sign.NITBUT]: { accessState: AccessState.PRO_LOCKED },
      [Sign.TEAR_MENISCUS_HEIGHT_IMAGING]: { accessState: AccessState.PRO_LOCKED },
      [Sign.OSMOLARITY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MMP9]: { accessState: AccessState.PRO_LOCKED },
      [Sign.PARTIAL_BLINKING_FREQUENCY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.BLINKING_FREQUENCY_PER_MIN]: { accessState: AccessState.PRO_LOCKED },
      [Sign.BLINK]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LID_APOSITION]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MEIBOGRAPHY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MEIBOGRAPHY_UPPER]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MEIBOGRAPHY_LOWER]: { accessState: AccessState.PRO_LOCKED },
      [Sign.EPITHELIAL_THICKNESS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LIPID_LAYER]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LIPID_LAYER_NASAL]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LIPID_LAYER_TEMPORAL]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CORNEAL_SENSATION]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CORNEAL_FINDINGS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.SCHIRMERS_TEST]: { accessState: AccessState.PRO_LOCKED },
      [Sign.SUPERIOR_CONJUNCTIVA_CORNEAL_FINDINGS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.PHENOL_RED]: { accessState: AccessState.PRO_LOCKED },
      [Sign.SMTUBE]: { accessState: AccessState.PRO_LOCKED },
      [Sign.FLOPPY_EYELID_SYNDROME_GRADING]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LAGOPHTHALMUS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LID_REDNESS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CONJUNCTIVAL_CHALASIS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CORNEAL_STAINING_PATTERN]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CORNEAL_STAINING_EXTENT]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LWE]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MGE_EXPRESSIBILITY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.OTHER]: { accessState: AccessState.PRO_LOCKED },
      [Sign.EYE_MARKUP]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MG_ORIFICE_NOTCHES]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LIMBAL_REDNESS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.UPPER_LID_LAXITY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.SNAP_BACK_LID_LAXITY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.KERATINIZATION]: { accessState: AccessState.PRO_LOCKED }
    },
    [SymptomModes.FollowUp]: {
      [Sign.ITBUT]: { accessState: AccessState.ENABLED },
      [Sign.FLUORESCEIN_STAINING]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_CAPPED_GLANDS]: { accessState: AccessState.ENABLED },
      [Sign.EYELID_TELANGIECTASIA]: { accessState: AccessState.ENABLED },
      [Sign.COLLARETTES]: { accessState: AccessState.ENABLED },
      [Sign.BULBAR_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.MGE_SECRETION]: { accessState: AccessState.ENABLED },
      [Sign.VA]: { accessState: AccessState.PRO_LOCKED },
      [Sign.PRESSURE]: { accessState: AccessState.PRO_LOCKED },
      [Sign.NITBUT]: { accessState: AccessState.PRO_LOCKED },
      [Sign.TEAR_MENISCUS_HEIGHT_IMAGING]: { accessState: AccessState.PRO_LOCKED },
      [Sign.OSMOLARITY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MMP9]: { accessState: AccessState.PRO_LOCKED },
      [Sign.PARTIAL_BLINKING_FREQUENCY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.BLINKING_FREQUENCY_PER_MIN]: { accessState: AccessState.PRO_LOCKED },
      [Sign.BLINK]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LID_APOSITION]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MEIBOGRAPHY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MEIBOGRAPHY_UPPER]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MEIBOGRAPHY_LOWER]: { accessState: AccessState.PRO_LOCKED },
      [Sign.EPITHELIAL_THICKNESS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LIPID_LAYER]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LIPID_LAYER_NASAL]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LIPID_LAYER_TEMPORAL]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CORNEAL_SENSATION]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CORNEAL_FINDINGS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.SCHIRMERS_TEST]: { accessState: AccessState.PRO_LOCKED },
      [Sign.SUPERIOR_CONJUNCTIVA_CORNEAL_FINDINGS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.PHENOL_RED]: { accessState: AccessState.PRO_LOCKED },
      [Sign.SMTUBE]: { accessState: AccessState.PRO_LOCKED },
      [Sign.FLOPPY_EYELID_SYNDROME_GRADING]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LAGOPHTHALMUS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LID_REDNESS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CONJUNCTIVAL_CHALASIS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CORNEAL_STAINING_PATTERN]: { accessState: AccessState.PRO_LOCKED },
      [Sign.CORNEAL_STAINING_EXTENT]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LWE]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MGE_EXPRESSIBILITY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.OTHER]: { accessState: AccessState.PRO_LOCKED },
      [Sign.EYE_MARKUP]: { accessState: AccessState.PRO_LOCKED },
      [Sign.MG_ORIFICE_NOTCHES]: { accessState: AccessState.PRO_LOCKED },
      [Sign.LIMBAL_REDNESS]: { accessState: AccessState.PRO_LOCKED },
      [Sign.UPPER_LID_LAXITY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.SNAP_BACK_LID_LAXITY]: { accessState: AccessState.PRO_LOCKED },
      [Sign.KERATINIZATION]: { accessState: AccessState.PRO_LOCKED }
    }
  },
  questionnaires: {
    [QuestionnaireType.OSDI]: { accessState: AccessState.ENABLED },
    [QuestionnaireType.OSDI6]: { accessState: AccessState.ENABLED },
    [QuestionnaireType.OSDIAndSPEED]: { accessState: AccessState.ENABLED },
    [QuestionnaireType.SPEED]: { accessState: AccessState.ENABLED },
    [QuestionnaireType.SPEEDII]: { accessState: AccessState.HIDDEN },
    [QuestionnaireType.FITZPATRICK]: { accessState: AccessState.HIDDEN },
    [QuestionnaireType.DEQ]: { accessState: AccessState.HIDDEN },
    [QuestionnaireType.DERFS]: { accessState: AccessState.HIDDEN },
    [QuestionnaireType.CDERFS]: { accessState: AccessState.HIDDEN },
    [QuestionnaireType.MEDICATION]: { accessState: AccessState.HIDDEN },
    [QuestionnaireType.DEWSIII_Q]: { accessState: AccessState.ENABLED }
  },
  intakeForms: {
    [IntakeFormType.STANDARD]: { accessState: AccessState.ENABLED },
    [IntakeFormType.CONTACT]: { accessState: AccessState.HIDDEN }
  },
  assessments: {
    [SymptomModes.PreOpScreening]: { accessState: AccessState.ENABLED },
    [SymptomModes.PreOp]: { accessState: AccessState.HIDDEN },
    [SymptomModes.Simple]: { accessState: AccessState.HIDDEN },
    [SymptomModes.Silver]: { accessState: AccessState.HIDDEN },
    [SymptomModes.Advanced]: { accessState: AccessState.ENABLED },
    [SymptomModes.Treatment]: { accessState: AccessState.HIDDEN },
    [SymptomModes.FollowUp]: { accessState: AccessState.ENABLED }
  },
  reports: {
    [PDFReportType.DETAILED]: { accessState: AccessState.ENABLED },
    [PDFReportType.SIMPLE]: { accessState: AccessState.HIDDEN },
    [PDFReportType.SUMMARY]: { accessState: AccessState.ENABLED },
    [PDFReportType.CUSTOM]: { accessState: AccessState.HIDDEN }
  },
  features: {
    [Feature.MULTI_CLINIC]: { accessState: AccessState.ENABLED },
    [Feature.COMPARE_ASSESSMENT]: { accessState: AccessState.ENABLED },
    [Feature.QUESTIONNAIRE_REMINDERS]: { accessState: AccessState.ENABLED },
    [Feature.EFAX]: { accessState: AccessState.HIDDEN },
    [Feature.MASS_CLINIC]: { accessState: AccessState.HIDDEN },
    [Feature.MEDIA_WIZARD]: { accessState: AccessState.ENABLED },
    [Feature.WELCOME_MESSAGE]: { accessState: AccessState.HIDDEN },
    [Feature.AI_SCRIBE]: { accessState: AccessState.ENABLED }
  },
  staffCounts: {
    [StaffType.Owner]: 1,
    [StaffType.Doctor]: 7
  },
  questionnaireDeliveryMethods: {
    [QuestionnaireDeliveryMethod.EMAIL]: { accessState: AccessState.ENABLED },
    [QuestionnaireDeliveryMethod.TEXT]: { accessState: AccessState.ADD_ON_LOCKED }
  }
};

export const proSubscriptionPlanSchema: SubscriptionPlanSchema = {
  signs: {
    [SymptomModes.Advanced]: {
      [Sign.VA]: { accessState: AccessState.ENABLED },
      [Sign.PRESSURE]: { accessState: AccessState.ENABLED },
      [Sign.FLUORESCEIN_STAINING]: { accessState: AccessState.ENABLED },
      [Sign.NITBUT]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT_IMAGING]: { accessState: AccessState.ENABLED },
      [Sign.OSMOLARITY]: { accessState: AccessState.ENABLED },
      [Sign.MMP9]: { accessState: AccessState.ENABLED },
      [Sign.PARTIAL_BLINKING_FREQUENCY]: { accessState: AccessState.ENABLED },
      [Sign.BLINKING_FREQUENCY_PER_MIN]: { accessState: AccessState.ENABLED },
      [Sign.BLINK]: { accessState: AccessState.ENABLED },
      [Sign.LID_APOSITION]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY_UPPER]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY_LOWER]: { accessState: AccessState.ENABLED },
      [Sign.EPITHELIAL_THICKNESS]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER_NASAL]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER_TEMPORAL]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_SENSATION]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_FINDINGS]: { accessState: AccessState.ENABLED },
      [Sign.SCHIRMERS_TEST]: { accessState: AccessState.ENABLED },
      [Sign.SUPERIOR_CONJUNCTIVA_CORNEAL_FINDINGS]: { accessState: AccessState.ENABLED },
      [Sign.PHENOL_RED]: { accessState: AccessState.ENABLED },
      [Sign.SMTUBE]: { accessState: AccessState.ENABLED },
      [Sign.FLOPPY_EYELID_SYNDROME_GRADING]: { accessState: AccessState.ENABLED },
      [Sign.LAGOPHTHALMUS]: { accessState: AccessState.ENABLED },
      [Sign.LID_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.COLLARETTES]: { accessState: AccessState.ENABLED },
      [Sign.EYELID_TELANGIECTASIA]: { accessState: AccessState.ENABLED },
      [Sign.CONJUNCTIVAL_CHALASIS]: { accessState: AccessState.ENABLED },
      [Sign.ITBUT]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_STAINING_PATTERN]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_STAINING_EXTENT]: { accessState: AccessState.ENABLED },
      [Sign.LWE]: { accessState: AccessState.ENABLED },
      [Sign.MGE_SECRETION]: { accessState: AccessState.ENABLED },
      [Sign.MGE_EXPRESSIBILITY]: { accessState: AccessState.ENABLED },
      [Sign.OTHER]: { accessState: AccessState.ENABLED },
      [Sign.EYE_MARKUP]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_CAPPED_GLANDS]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_NOTCHES]: { accessState: AccessState.ENABLED },
      [Sign.BULBAR_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.LIMBAL_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.UPPER_LID_LAXITY]: { accessState: AccessState.ENABLED },
      [Sign.SNAP_BACK_LID_LAXITY]: { accessState: AccessState.ENABLED },
      [Sign.KERATINIZATION]: { accessState: AccessState.ENABLED }
    },
    [SymptomModes.PreOpScreening]: {
      [Sign.VA]: { accessState: AccessState.ENABLED },
      [Sign.PRESSURE]: { accessState: AccessState.ENABLED },
      [Sign.FLUORESCEIN_STAINING]: { accessState: AccessState.ENABLED },
      [Sign.NITBUT]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT_IMAGING]: { accessState: AccessState.ENABLED },
      [Sign.OSMOLARITY]: { accessState: AccessState.ENABLED },
      [Sign.MMP9]: { accessState: AccessState.ENABLED },
      [Sign.PARTIAL_BLINKING_FREQUENCY]: { accessState: AccessState.ENABLED },
      [Sign.BLINKING_FREQUENCY_PER_MIN]: { accessState: AccessState.ENABLED },
      [Sign.BLINK]: { accessState: AccessState.ENABLED },
      [Sign.LID_APOSITION]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY_UPPER]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY_LOWER]: { accessState: AccessState.ENABLED },
      [Sign.EPITHELIAL_THICKNESS]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER_NASAL]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER_TEMPORAL]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_SENSATION]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_FINDINGS]: { accessState: AccessState.ENABLED },
      [Sign.SCHIRMERS_TEST]: { accessState: AccessState.ENABLED },
      [Sign.SUPERIOR_CONJUNCTIVA_CORNEAL_FINDINGS]: { accessState: AccessState.ENABLED },
      [Sign.PHENOL_RED]: { accessState: AccessState.ENABLED },
      [Sign.SMTUBE]: { accessState: AccessState.ENABLED },
      [Sign.FLOPPY_EYELID_SYNDROME_GRADING]: { accessState: AccessState.ENABLED },
      [Sign.LAGOPHTHALMUS]: { accessState: AccessState.ENABLED },
      [Sign.LID_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.COLLARETTES]: { accessState: AccessState.ENABLED },
      [Sign.EYELID_TELANGIECTASIA]: { accessState: AccessState.ENABLED },
      [Sign.CONJUNCTIVAL_CHALASIS]: { accessState: AccessState.ENABLED },
      [Sign.ITBUT]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_STAINING_PATTERN]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_STAINING_EXTENT]: { accessState: AccessState.ENABLED },
      [Sign.LWE]: { accessState: AccessState.ENABLED },
      [Sign.MGE_SECRETION]: { accessState: AccessState.ENABLED },
      [Sign.MGE_EXPRESSIBILITY]: { accessState: AccessState.ENABLED },
      [Sign.OTHER]: { accessState: AccessState.ENABLED },
      [Sign.EYE_MARKUP]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_CAPPED_GLANDS]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_NOTCHES]: { accessState: AccessState.ENABLED },
      [Sign.BULBAR_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.LIMBAL_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.UPPER_LID_LAXITY]: { accessState: AccessState.ENABLED },
      [Sign.SNAP_BACK_LID_LAXITY]: { accessState: AccessState.ENABLED },
      [Sign.KERATINIZATION]: { accessState: AccessState.ENABLED }
    },
    [SymptomModes.Treatment]: {
      [Sign.VA]: { accessState: AccessState.ENABLED },
      [Sign.PRESSURE]: { accessState: AccessState.ENABLED },
      [Sign.FLUORESCEIN_STAINING]: { accessState: AccessState.ENABLED },
      [Sign.NITBUT]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT_IMAGING]: { accessState: AccessState.ENABLED },
      [Sign.OSMOLARITY]: { accessState: AccessState.ENABLED },
      [Sign.MMP9]: { accessState: AccessState.ENABLED },
      [Sign.PARTIAL_BLINKING_FREQUENCY]: { accessState: AccessState.ENABLED },
      [Sign.BLINKING_FREQUENCY_PER_MIN]: { accessState: AccessState.ENABLED },
      [Sign.BLINK]: { accessState: AccessState.ENABLED },
      [Sign.LID_APOSITION]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY_UPPER]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY_LOWER]: { accessState: AccessState.ENABLED },
      [Sign.EPITHELIAL_THICKNESS]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER_NASAL]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER_TEMPORAL]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_SENSATION]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_FINDINGS]: { accessState: AccessState.ENABLED },
      [Sign.SCHIRMERS_TEST]: { accessState: AccessState.ENABLED },
      [Sign.SUPERIOR_CONJUNCTIVA_CORNEAL_FINDINGS]: { accessState: AccessState.ENABLED },
      [Sign.PHENOL_RED]: { accessState: AccessState.ENABLED },
      [Sign.SMTUBE]: { accessState: AccessState.ENABLED },
      [Sign.FLOPPY_EYELID_SYNDROME_GRADING]: { accessState: AccessState.ENABLED },
      [Sign.LAGOPHTHALMUS]: { accessState: AccessState.ENABLED },
      [Sign.LID_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.COLLARETTES]: { accessState: AccessState.ENABLED },
      [Sign.EYELID_TELANGIECTASIA]: { accessState: AccessState.ENABLED },
      [Sign.CONJUNCTIVAL_CHALASIS]: { accessState: AccessState.ENABLED },
      [Sign.ITBUT]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_STAINING_PATTERN]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_STAINING_EXTENT]: { accessState: AccessState.ENABLED },
      [Sign.LWE]: { accessState: AccessState.ENABLED },
      [Sign.MGE_SECRETION]: { accessState: AccessState.ENABLED },
      [Sign.MGE_EXPRESSIBILITY]: { accessState: AccessState.ENABLED },
      [Sign.OTHER]: { accessState: AccessState.ENABLED },
      [Sign.EYE_MARKUP]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_CAPPED_GLANDS]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_NOTCHES]: { accessState: AccessState.ENABLED },
      [Sign.BULBAR_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.LIMBAL_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.UPPER_LID_LAXITY]: { accessState: AccessState.ENABLED },
      [Sign.SNAP_BACK_LID_LAXITY]: { accessState: AccessState.ENABLED },
      [Sign.KERATINIZATION]: { accessState: AccessState.ENABLED }
    },
    [SymptomModes.FollowUp]: {
      [Sign.VA]: { accessState: AccessState.ENABLED },
      [Sign.PRESSURE]: { accessState: AccessState.ENABLED },
      [Sign.FLUORESCEIN_STAINING]: { accessState: AccessState.ENABLED },
      [Sign.NITBUT]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT_IMAGING]: { accessState: AccessState.ENABLED },
      [Sign.OSMOLARITY]: { accessState: AccessState.ENABLED },
      [Sign.MMP9]: { accessState: AccessState.ENABLED },
      [Sign.PARTIAL_BLINKING_FREQUENCY]: { accessState: AccessState.ENABLED },
      [Sign.BLINKING_FREQUENCY_PER_MIN]: { accessState: AccessState.ENABLED },
      [Sign.BLINK]: { accessState: AccessState.ENABLED },
      [Sign.LID_APOSITION]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY_UPPER]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY_LOWER]: { accessState: AccessState.ENABLED },
      [Sign.EPITHELIAL_THICKNESS]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER_NASAL]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER_TEMPORAL]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_SENSATION]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_FINDINGS]: { accessState: AccessState.ENABLED },
      [Sign.SCHIRMERS_TEST]: { accessState: AccessState.ENABLED },
      [Sign.SUPERIOR_CONJUNCTIVA_CORNEAL_FINDINGS]: { accessState: AccessState.ENABLED },
      [Sign.PHENOL_RED]: { accessState: AccessState.ENABLED },
      [Sign.SMTUBE]: { accessState: AccessState.ENABLED },
      [Sign.FLOPPY_EYELID_SYNDROME_GRADING]: { accessState: AccessState.ENABLED },
      [Sign.LAGOPHTHALMUS]: { accessState: AccessState.ENABLED },
      [Sign.LID_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.COLLARETTES]: { accessState: AccessState.ENABLED },
      [Sign.EYELID_TELANGIECTASIA]: { accessState: AccessState.ENABLED },
      [Sign.CONJUNCTIVAL_CHALASIS]: { accessState: AccessState.ENABLED },
      [Sign.ITBUT]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_STAINING_PATTERN]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_STAINING_EXTENT]: { accessState: AccessState.ENABLED },
      [Sign.LWE]: { accessState: AccessState.ENABLED },
      [Sign.MGE_SECRETION]: { accessState: AccessState.ENABLED },
      [Sign.MGE_EXPRESSIBILITY]: { accessState: AccessState.ENABLED },
      [Sign.OTHER]: { accessState: AccessState.ENABLED },
      [Sign.EYE_MARKUP]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_CAPPED_GLANDS]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_NOTCHES]: { accessState: AccessState.ENABLED },
      [Sign.BULBAR_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.LIMBAL_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.UPPER_LID_LAXITY]: { accessState: AccessState.ENABLED },
      [Sign.SNAP_BACK_LID_LAXITY]: { accessState: AccessState.ENABLED },
      [Sign.KERATINIZATION]: { accessState: AccessState.ENABLED }
    },
    [SymptomModes.Silver]: {
      [Sign.VA]: { accessState: AccessState.ENABLED },
      [Sign.PRESSURE]: { accessState: AccessState.ENABLED },
      [Sign.FLUORESCEIN_STAINING]: { accessState: AccessState.ENABLED },
      [Sign.NITBUT]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT]: { accessState: AccessState.ENABLED },
      [Sign.TEAR_MENISCUS_HEIGHT_IMAGING]: { accessState: AccessState.ENABLED },
      [Sign.OSMOLARITY]: { accessState: AccessState.ENABLED },
      [Sign.MMP9]: { accessState: AccessState.ENABLED },
      [Sign.PARTIAL_BLINKING_FREQUENCY]: { accessState: AccessState.ENABLED },
      [Sign.BLINKING_FREQUENCY_PER_MIN]: { accessState: AccessState.ENABLED },
      [Sign.BLINK]: { accessState: AccessState.ENABLED },
      [Sign.LID_APOSITION]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY_UPPER]: { accessState: AccessState.ENABLED },
      [Sign.MEIBOGRAPHY_LOWER]: { accessState: AccessState.ENABLED },
      [Sign.EPITHELIAL_THICKNESS]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER_NASAL]: { accessState: AccessState.ENABLED },
      [Sign.LIPID_LAYER_TEMPORAL]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_SENSATION]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_FINDINGS]: { accessState: AccessState.ENABLED },
      [Sign.SCHIRMERS_TEST]: { accessState: AccessState.ENABLED },
      [Sign.SUPERIOR_CONJUNCTIVA_CORNEAL_FINDINGS]: { accessState: AccessState.ENABLED },
      [Sign.PHENOL_RED]: { accessState: AccessState.ENABLED },
      [Sign.SMTUBE]: { accessState: AccessState.ENABLED },
      [Sign.FLOPPY_EYELID_SYNDROME_GRADING]: { accessState: AccessState.ENABLED },
      [Sign.LAGOPHTHALMUS]: { accessState: AccessState.ENABLED },
      [Sign.LID_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.COLLARETTES]: { accessState: AccessState.ENABLED },
      [Sign.EYELID_TELANGIECTASIA]: { accessState: AccessState.ENABLED },
      [Sign.CONJUNCTIVAL_CHALASIS]: { accessState: AccessState.ENABLED },
      [Sign.ITBUT]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_STAINING_PATTERN]: { accessState: AccessState.ENABLED },
      [Sign.CORNEAL_STAINING_EXTENT]: { accessState: AccessState.ENABLED },
      [Sign.LWE]: { accessState: AccessState.ENABLED },
      [Sign.MGE_SECRETION]: { accessState: AccessState.ENABLED },
      [Sign.MGE_EXPRESSIBILITY]: { accessState: AccessState.ENABLED },
      [Sign.OTHER]: { accessState: AccessState.ENABLED },
      [Sign.EYE_MARKUP]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_CAPPED_GLANDS]: { accessState: AccessState.ENABLED },
      [Sign.MG_ORIFICE_NOTCHES]: { accessState: AccessState.ENABLED },
      [Sign.BULBAR_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.LIMBAL_REDNESS]: { accessState: AccessState.ENABLED },
      [Sign.UPPER_LID_LAXITY]: { accessState: AccessState.ENABLED },
      [Sign.SNAP_BACK_LID_LAXITY]: { accessState: AccessState.ENABLED },
      [Sign.KERATINIZATION]: { accessState: AccessState.ENABLED }
    }
  },
  questionnaires: {
    [QuestionnaireType.OSDI]: { accessState: AccessState.ENABLED },
    [QuestionnaireType.OSDIAndSPEED]: { accessState: AccessState.ENABLED },
    [QuestionnaireType.SPEED]: { accessState: AccessState.ENABLED },
    [QuestionnaireType.SPEEDII]: { accessState: AccessState.ENABLED },
    [QuestionnaireType.FITZPATRICK]: { accessState: AccessState.ENABLED },
    [QuestionnaireType.DEQ]: { accessState: AccessState.ENABLED },
    [QuestionnaireType.CDERFS]: { accessState: AccessState.ENABLED },
    [QuestionnaireType.DEWSIII_Q]: { accessState: AccessState.ENABLED }
  },
  intakeForms: {
    [IntakeFormType.STANDARD]: { accessState: AccessState.ENABLED }
  },
  assessments: {
    [SymptomModes.PreOpScreening]: { accessState: AccessState.ENABLED },
    [SymptomModes.PreOp]: { accessState: AccessState.ENABLED },
    [SymptomModes.Simple]: { accessState: AccessState.HIDDEN },
    [SymptomModes.Silver]: { accessState: AccessState.ENABLED },
    [SymptomModes.Advanced]: { accessState: AccessState.ENABLED },
    [SymptomModes.Treatment]: { accessState: AccessState.ENABLED },
    [SymptomModes.FollowUp]: { accessState: AccessState.ENABLED }
  },
  reports: {
    [PDFReportType.DETAILED]: { accessState: AccessState.ENABLED },
    [PDFReportType.CUSTOM]: { accessState: AccessState.ENABLED },
    [PDFReportType.SIMPLE]: { accessState: AccessState.ENABLED },
    [PDFReportType.SUMMARY]: { accessState: AccessState.ENABLED }
  },
  features: {
    [Feature.MULTI_CLINIC]: { accessState: AccessState.ENABLED },
    [Feature.COMPARE_ASSESSMENT]: { accessState: AccessState.ENABLED },
    [Feature.QUESTIONNAIRE_REMINDERS]: { accessState: AccessState.ENABLED },
    [Feature.MASS_CLINIC]: { accessState: AccessState.HIDDEN },
    [Feature.AI_SCRIBE]: { accessState: AccessState.ENABLED }
  },
  staffCounts: {
    [StaffType.Owner]: 1,
    [StaffType.Doctor]: 25
  },
  questionnaireDeliveryMethods: {
    [QuestionnaireDeliveryMethod.EMAIL]: { accessState: AccessState.ENABLED },
    [QuestionnaireDeliveryMethod.TEXT]: { accessState: AccessState.ENABLED }
  }
};

/**
 * Features hidden on every plan (including full) unless enabled via subscriptionPlanAddOns.
 * Applied on top of the plan schema, before add-ons are merged.
 */
export const addOnOnlySubscriptionPlanSchema: SubscriptionPlanSchema = {
  features: {
    [Feature.NUTRITION_BASED_TESTING]: { accessState: AccessState.HIDDEN }
  }
};

const test = {
  'signs.ITBUT': {
    accessState: 'ENABLED'
  },
  'signs.FLUORESCEIN_STAINING': {
    accessState: 'ENABLED'
  },
  'signs.TEAR_MENISCUS_HEIGHT': {
    accessState: 'ENABLED'
  },
  'signs.MG_ORIFICE_CAPPED_GLANDS': {
    accessState: 'ENABLED'
  },
  'signs.EYELID_TELANGIECTASIA': {
    accessState: 'ENABLED'
  },
  'signs.COLLARETTES': {
    accessState: 'ENABLED'
  },
  'signs.BULBAR_REDNESS': {
    accessState: 'ENABLED'
  },
  'signs.MGE_SECRETION': {
    accessState: 'ENABLED'
  },
  'questionnaires.OSDI': {
    accessState: 'ENABLED'
  },
  'questionnaires.OSDIAndSPEED': {
    accessState: 'ENABLED'
  },
  'questionnaires.SPEED': {
    accessState: 'ENABLED'
  },
  'questionnaires.FITZPATRICK': {
    accessState: 'ENABLED'
  },
  'questionnaires.DEQ': {
    accessState: 'ENABLED'
  },
  'intakeForms.standard_intakeForm': {
    accessState: 'ENABLED'
  },
  'assessments.preop': {
    accessState: 'ENABLED'
  },
  'assessments.advanced': {
    accessState: 'ENABLED'
  },
  'assessments.followUp': {
    accessState: 'ENABLED'
  },
  'reports.detailed': {
    accessState: 'ENABLED'
  },
  'reports.summary': {
    accessState: 'ENABLED'
  },
  'features.MULTI_CLINIC': {
    accessState: 'ENABLED'
  },
  'features.COMPARE_ASSESSMENT': {
    accessState: 'ENABLED'
  },
  'features.QUESTIONNAIRE_REMINDERS': {
    accessState: 'ENABLED'
  },
  'staffCounts.Owner': 1,
  'staffCounts.Doctor': 7,
  'questionnaireDeliveryMethods.EMAIL': {
    accessState: 'ENABLED'
  }
};
